/**
 * Convert two arrays into an array of tuples. if a is longer than b, if a and b are not the same length, the result will be the length of the shortest array
 */
export function zip<T, U>(a: readonly T[], b: readonly U[]): [T, U][] {
  return a.slice(0, Math.min(a.length, b.length)).map((cur, idx) => [cur, b[idx]])
}
